import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginScreen } from '@/components/ui/admin/login';
import { Icon } from '@/components/ui/icon';
import { useSignIn } from '@/services/auth';

export const Route = createFileRoute('/_auth/sign-in')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isAuthenticated) {
      return redirect({ to: '/' });
    }
  },
  component: RouteComponent,
});

export function RouteComponent() {
  const { mutate: signIn, isPending, isSuccess, error, reset } = useSignIn();

  return (
    <LoginScreen
      // Após o sucesso o router ainda leva ~400ms para redirecionar: mantém o spinner.
      forgotHref="/forgot-password"
      loading={isPending || isSuccess}
      error={error?.message}
      onClearError={() => error && reset()}
      onSubmit={({ email, password, remember }) =>
        signIn({ email, password, rememberMe: remember })
      }
      alertIcon={<Icon name="circle-alert" className="size-4" />}
      arrowIcon={<Icon name="arrow-right" className="size-4" />}
      shieldIcon={<Icon name="shield" className="size-3.5" />}
    />
  );
}
